import type { Dispatch } from 'react';
import { ErpSection } from '../tenant-sections/ErpSection';
import type { WizardAction, WizardDraft } from './types';

/** Paso 4 del wizard = la sección Integración montada en modo wizard. */
export function Step4ErpSelector({
  draft,
  dispatch,
}: {
  draft: WizardDraft;
  dispatch: Dispatch<WizardAction>;
}) {
  return (
    <ErpSection
      mode="wizard"
      testId="wizard-step-4"
      tenantId={draft?.tenantId ?? ''}
      value={{
        type: draft?.erp?.type,
        config: (draft?.erp?.config as Record<string, string>) ?? {},
      }}
      onSaved={(patch) => {
        const p = patch as { type: 'medical-ese-sf' | 'mock'; config: Record<string, string> };
        dispatch({ type: 'set-erp', erp: { type: p.type, config: p.config } });
        dispatch({ type: 'goto', step: 5 });
      }}
    />
  );
}
